export const authHttpKey = 'Authorization';
export const authHttpPrefix = 'Bearer ';
